module.exports = __webpack_public_path__ + "img/success.a5f5eb31.png";